import { flatRoutes } from 'helpers';
import { AppRouteNamesList } from 'models';
import { AppRouteList } from './AppRouteList';

export const AppPathList = AppRouteList.map((moduleRoute) =>
	flatRoutes(moduleRoute),
)
	.flat()
	.reduce((res: Partial<Record<AppRouteNamesList, string>>, route) => {
		return {
			...res,
			[route.name]: route.path,
		};
	}, {}) as Record<AppRouteNamesList, string>;

export function getModulePathWithId(route: AppRouteNamesList, id: string) {
	return AppPathList[route]?.replace(/:\w+/, id) || '/';
}
